jQuery(document).ready(function($){
    $('.header__desktop__toggle_mobile_menu').click(function(){
        $('.mobile_menu').show();
        tabWithinMobileMenu();
        setTimeout(function(){ 
            $('.mobile_menu').addClass('show');
            $('body').css('overflow-y', 'hidden');
            setInnerMenuHeight();
        }, 1);
    });
    $('.mobile_menu__close__icon').click(function(){
        tabWithinBody();
        setTimeout(function(){
            $('.mobile_menu').removeClass('show');
            $('body').css('overflow-y', 'scroll');
            
        }, 1);
        // setTimeout(function(){
        //     $('.mobile_menu').hide();      
        // }, 500);
    });
    $('.mobile_menu__content__back').click(function(){
        var selected_menu = $('#mobile_menu__content_menu .menu-item a.selected');
        $('#mobile_menu__content_menu a.selected').removeClass('selected');
        $('#mobile_menu__content_menu .menu-item').hide();
        var closest_menu = selected_menu.closest('ul');
        if (closest_menu.hasClass('sub-menu')){
            console.log('still nested');
            selected_menu.closest('ul').parents('.menu-item').show();
            selected_menu.closest('ul').closest('.menu-item').find('>a').show().addClass('selected');
            selected_menu.closest('ul').show();
            selected_menu.closest('ul').find('>.menu-item').show();
        }
        else{
            console.log('at the top');
            $(this).hide();
            selected_menu.closest('ul').show();
            selected_menu.closest('ul').find('>.menu-item').show();
        }
        selected_menu.closest('ul').find('.menu-item-has-children .toggle_sub_menu').show();
    });

    $(document).on('click', '#mobile_menu__content_menu .toggle_sub_menu2', function(e){
        e.preventDefault();
        $('#mobile_menu__content_menu .menu-item a ').removeClass('selected');
        $('#mobile_menu__content_menu .toggle_sub_menu').hide();
        $(this).closest('.menu-item-has-children').find('.menu-item-has-children .toggle_sub_menu').show();
        $(this).closest('.menu-item').find('>a').addClass('selected');
        $('.mobile_menu__content__back').show();

        //hide all menu items
        $('#mobile_menu__content_menu .menu-item').hide();
        $(this).parents('.menu-item').show();
        $(this).parents('.sub-menu').siblings('a').hide();
        $(this).parents('.sub-menu').show();

        //show only immediate child menu items
        $(this).closest('.menu-item').show();
        $(this).closest('.menu-item').find('.sub-menu').show();
        $(this).closest('.menu-item').find('>.sub-menu > .menu-item').show();
    });

    addCaretsToMobileMenu();

    function controlSubMenu($element){
        console.log($element);
    }

    function addCaretsToMobileMenu(){
        $('#mobile_menu__content_menu li.menu-item-has-children >a').addClass("toggle_sub_menu2");
        $('#mobile_menu__content_menu li.menu-item-has-children >a').css("cursor", "pointer");
        $('#mobile_menu__content_menu li.menu-item-has-children >a').after('<button title="toggle sub menu"          class="toggle_sub_menu toggle_sub_menu2"><span class="fas fa-caret-right toggle_sub_menu__inner"></span></button>');
    }
    
    $(window).on('resize', function(){
        setInnerMenuHeight();
    })
    
    function setInnerMenuHeight(){
        var mobile_menu_height = $('.mobile_menu__content').height();
        var go_back_height = $('.mobile_menu__content__back').outerHeight();
        var button_height = $('.mobile_menu__content__btn').outerHeight();


        var menu_height  = mobile_menu_height - go_back_height - button_height - 20;


        $('#mobile_menu__content_menu').css('height', mobile_menu_height);
    }

    function tabWithinMobileMenu(){
        $('main, header, footer').attr('aria-hidden', 'true')
        $("main :focusable, header :focusable, footer :focusable").addClass("disabled-tab").attr("tabindex", -1);

    }

    function tabWithinBody(){
        $('main, header, footer').attr('aria-hidden', 'false')
        $(".disabled-tab").removeClass("disabled-tab").attr("tabindex", 0);

    }

});

(function($) {
	function visible(element) {
		return $.expr.filters.visible(element) && !$(element).parents().addBack().filter(function() {
			return $.css(this, 'visibility') === 'hidden';
		}).length;
	}

	function focusable(element, isTabIndexNotNaN) {
		var map, mapName, img, nodeName = element.nodeName.toLowerCase();
		if ('area' === nodeName) {
			map = element.parentNode;
			mapName = map.name;
			if (!element.href || !mapName || map.nodeName.toLowerCase() !== 'map') {
				return false;
			}
			img = $('img[usemap=#' + mapName + ']')[0];
			return !!img && visible(img);
		}
		return (/input|select|textarea|button|object/.test(nodeName) ?
			!element.disabled :
			'a' === nodeName ?
				element.href || isTabIndexNotNaN :
				isTabIndexNotNaN) &&
			// the element and all of its ancestors must be visible
			visible(element);
	}

	$.extend($.expr[':'], {
		focusable: function(element) {
			return focusable(element, !isNaN($.attr(element, 'tabindex')));
		}
    });
    
    $(window).on( 'breakpoint_changed', function (newSize, oldSize) {
        setTimeout(function(){
            $('.mobile_menu').removeClass('show');
            $('body').css('overflow-y', 'scroll');    
        }, 1);
        
        // if ( newSize == "xl" ){
        //     console.log("test");
        //     $('.menu-item').each(function(index, value){
        //         $(this).css('display', 'flex');
        //     });
        // }
    });

})(jQuery);